import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions.
import * as AuthActions from 'actions/AuthActions';

@connect(
  state => ({
    user: state.user,
  }),
  dispatch => ({
    actions: bindActionCreators(AuthActions, dispatch),
  })
)
export default class LogoutPage extends Component {

  static propTypes = {
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const isRedirect = true;
    this.props.actions.logout(isRedirect);
  }

  render() {
    return null;
  }

}